import {useUserData} from '../../../../hooks'
import {useUiLayoutStore} from '../../../../stores'
import type {UserData} from '../../../../types'
import {CabinetFinancesSideMenuLinks} from './CabinetFinancesSideMenuLinks'
import {CabinetFinancesSideMenuUserInfo} from './CabinetFinancesSideMenuUserInfo'

// Левое меню в ЛК пользователя с информацией о контракте и ссылками на разделы ЛК.
export function CabinetFinancesSideMenu() {

    const user: UserData = useUserData()!

    const bootstrapSize = useUiLayoutStore(
        state => state.bootstrapSize
    )

    if (
        !user
        || bootstrapSize === 'xs'
        || bootstrapSize === 'sm'
        || bootstrapSize === 'md'
    ) {
        return null
    }

    return (
        <>
            <CabinetFinancesSideMenuUserInfo />
            <CabinetFinancesSideMenuLinks />
        </>
    )
}
